import { useEffect, useState, useCallback } from 'react';

import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Divider from '@mui/material/Divider';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

// import FilterTowerType from './FilterTowerType';
// import FilterTowerHeight from './FilterTowerHeight';

const Filters = {
    "distance": null,
    "height": [],
    "collocation": null,
    "types": null,
    "rad1": [],
    "rad2": [],
    "groundSpace": null,
    "resetAll": false
  }

const distances = [
    '5', '10', '25', '50'
];


const FiltersDialog = ({ dialogOpen, setDialogOpen, searchMarker, towerFilters, setTowerFilters }) => {
    const [selectedDistance, setSelectedDistance] = useState(towerFilters['distance']);
    const [clearAll, setClearAll] = useState(false);
    
    const handleClearAll = () => {
        setClearAll(true);
        setTowerFilters(Filters);
        setTimeout(() => {
            setClearAll(false);
          }, "100");
    };

    const handleDistanceChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedDistance(value);
    };

    const handleApplyClick = (e) => {
        let v = { distance: (selectedDistance === "0" ? null : selectedDistance) };
        setTowerFilters(towerFilters => ({ ...towerFilters, ...v }));
    };

    const handleClearClick = useCallback(() => {
        let v = { distance: null };
        setTowerFilters(towerFilters => ({ ...towerFilters, ...v }));
    }, [setTowerFilters]);

    useEffect(() => {
        if (searchMarker === null) handleClearClick();
    }, [searchMarker, handleClearClick]);

    useEffect(() => {
        setSelectedDistance(towerFilters.distance === null ? '' : towerFilters.distance)
    }, [towerFilters.distance]);

    const handleClose = () => {
        setDialogOpen(false);
    };


    return (

        <Dialog
        open={dialogOpen}
        onClose={handleClose}
        keepMounted={true}
        PaperProps={{
            sx: {
                o: '90%',
                height: '90vh'
            }
        }}
    >
        <DialogTitle>Filters</DialogTitle>
        <DialogContent>
            <DialogContentText>
                Select your filters:
            </DialogContentText>

            <Divider sx={{ paddingTop: '15px' }} />
            <Typography >Set Distance:</Typography>
            <RadioGroup
                row
                onChange={handleDistanceChange}
                value={selectedDistance}
            >
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    {distances.map((distance) => (
                        <Grid item xs={6} sm={3} key={distance}>
                            <MenuItem sx={{ px: '5px' }} value={distance} dense={true} key={distance} >
                                <FormControlLabel disabled={searchMarker === null} value={distance} control={<Radio size="small" checked={selectedDistance === distance} />} label={distance + " Miles"} />
                            </MenuItem>
                        </Grid>
                    ))}
                </Grid>
            </RadioGroup>

            <Grid
                m={1}
                display="flex"
                justifyContent="flex-end"
                alignItems="flex-end"
            >
                <Box pr={1}>
                  <Button disabled={towerFilters.distance === null} size="small" variant="text" onClick={handleClearClick}>Clear</Button>
                </Box>
                <Box>
                    <Button disabled={searchMarker === null} size="small" variant="contained" onClick={handleApplyClick}>Apply</Button>
                </Box>
            </Grid>

            {/* <Divider sx={{ py: '5px' }} />
            <FilterTowerHeight dialogOpen={dialogOpen} towerFilters={towerFilters} setTowerFilters={setTowerFilters} clearAll={clearAll} />

            <Divider sx={{ py: '5px' }} />
            <FilterTowerType dialogOpen={dialogOpen} towerFilters={towerFilters} setTowerFilters={setTowerFilters} clearAll={clearAll} /> */}

        </DialogContent>
        <DialogActions>
        <Button disabled={JSON.stringify(towerFilters) === JSON.stringify(Filters)} onClick={handleClearAll}>Clear All</Button>
            <Button variant="contained" onClick={handleClose}>Close</Button>
        </DialogActions>
    </Dialog>
  
    );
}

export default FiltersDialog;